module.exports = __webpack_public_path__ + "images/icons/icon-payment-american_express-c491838e.svg";